import 'css-chunksrc/client/pages/searchPage/searchResults/task/status/styles.scss';export default {
  "status": "_status_qltab_1",
  "square": "_square_qltab_9",
  "paragraph": "_paragraph_qltab_18"
};